import type { ReactNode } from 'react'

import { Text } from './Text'
import './system.css'

export function KeyValue({
  label,
  mono = false,
  tone = false,
  children,
}: {
  label: string
  mono?: boolean
  tone?: boolean
  children: ReactNode
}) {
  return (
    <div className="keyvalue">
      <Text role="eyebrow" tone="muted">
        {label}
      </Text>
      <Text
        role={mono ? 'code' : 'body'}
        tone={tone ? 'tone' : 'default'}
        {...(mono ? { className: 'keyvalue__value--mono' } : {})}
      >
        {children}
      </Text>
    </div>
  )
}
